import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { Switch, Route } from 'react-router'
import ManageAutoReply from './manage-auto-reply'
import AutoReplyDashboard from './auto-reply-dashboard'
import CreateEditAutoReply from './create-edit-auto-reply'

const AutoReply = () => {
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <title>{t('l.settings.view.auto_reply.label', 'Auto-Reply')}</title>
      </Helmet>
      <Switch>
        <Route exact path="/settings/auto-reply/manage" component={ManageAutoReply} />
        <Route
          exact
          path="/settings/auto-reply/auto-reply-message/:mode(create|edit)"
          component={CreateEditAutoReply}
        />
        <Route exact path="/settings/auto-reply" component={AutoReplyDashboard} />
      </Switch>
    </>
  )
}

export default AutoReply
